import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { repharsePrompt } from '../../../services/chatgptService';
import { useState, useEffect } from 'react';

const PromptInput = ({ 
  productPrompt,
  refImagePrompt,
  prompt, 
  setPrompt, 
  isRephrasing, 
  setIsRephrasing,
  setIsRephraseClicked,
  promptPlaceholder,
  repharseAllowed
}) => {
  const [showTooltip, setShowTooltip] = useState(false);



  const handleRephraseClick = async () => {
    setIsRephraseClicked(true);
    
    // console.log("*******productPrompt=", productPrompt)
    // console.log("*******refImagePrompt=", refImagePrompt)
    // console.log("*******prompt=", prompt)

    setIsRephrasing(true);
    const finalPrompt = await repharsePrompt(productPrompt + refImagePrompt + prompt);
    setPrompt(finalPrompt);
    setIsRephrasing(false);
  };

  const tooltipText = prompt.trim() ? "Click to enhance the prompt" : "Click to generate a new prompt";

  return (
    <div className="relative">
      <textarea
        className="w-full p-3 border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 bg-white focus:outline-none focus:ring-2 focus:ring-[#4B3BFF] focus:border-transparent text-xs" // Reduced padding from p-4 to p-3 and font size from text-sm to text-xs
        placeholder={promptPlaceholder}
        rows="5" // Increased from 4 to 6 for taller input box
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
      ></textarea>
      
      <div className="absolute bottom-2 right-2 flex gap-2">
        {repharseAllowed && (
          <div className="relative">
            <button
              onClick={handleRephraseClick}
              disabled={isRephrasing}
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              className={`p-1.5 rounded-lg transition-all duration-300 bg-white hover:bg-gray-50 ${isRephrasing // Reduced padding from p-2 to p-1.5
                ? 'cursor-not-allowed'
                : 'cursor-pointer'
                }`}
            >
              <FontAwesomeIcon
                icon={faWandMagicSparkles}
                className={`text-black ${isRephrasing ? 'animate-spin' : ''}`}
                size="sm" // Reduced icon size
              />
            </button>
            
            {/* Custom Tooltip */}
            {showTooltip && (
              <div className="absolute bottom-full right-0 mb-2 px-2 py-1 bg-white text-black text-xs rounded-lg shadow-lg whitespace-nowrap z-10 border border-purple-500"> {/* Reduced padding from px-3 py-2 to px-2 py-1 */}
                {tooltipText}
                {/* Tooltip arrow */}
                <div className="absolute top-full right-3 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-purple-500"></div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PromptInput; 